<ion-col class="flex-align-center">
    <ion-grid>
        <ion-row>
            <ion-col size="12">
                <h2 class="page-title">Configurações de Single Sign-On (SSO)</h2>
            </ion-col>
        </ion-row>

        <ion-row *ngFor="let item of config?.ConfigList">

            <ion-col size="12">
                <ion-card>
                    <ion-card-header>
                        <ion-card-title>
                            Configuração SSO
                            <ion-badge color="success">Ativo</ion-badge>
                        </ion-card-title>
                    </ion-card-header>

                    <ion-card-content>
                        <!-- Informações Básicas -->
                        <div class="detail-grid single-col">
                            <div class="detail-item">
                                <ion-icon name="information-circle-outline"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">ID</span>
                                    <span class="detail-value">{{ item?.Id }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="detail-grid">
                            <div class="detail-item">
                                <ion-icon name="calendar-outline"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">Criado em</span>
                                    <span class="detail-value">{{ item?.CreateDate | date:'medium' }}</span>
                                </div>
                            </div>
                            <div class="detail-item">
                                <ion-icon name="person-outline"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">Criado por</span>
                                    <span class="detail-value">{{ item?.CreateUser }}</span>
                                </div>
                            </div>
                        </div>

                        <!-- Configurações de Autenticação -->
                        <ion-item-divider>
                            <ion-label>Autenticação</ion-label>
                        </ion-item-divider>

                        <div class="detail-grid single-col">
                            <div class="detail-item">
                                <ion-icon name="key-outline"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">Client ID</span>
                                    <span class="detail-value">
                                        <ion-text class="sensitive-data">••••••••••••</ion-text>
                                        <ion-button fill="clear" size="small"
                                            (click)="toggleSSOClientIdVisibility(item)">
                                            <ion-icon
                                                [name]="item.showClientId ? 'eye-off-outline' : 'eye-outline'"></ion-icon>
                                        </ion-button>
                                        <span *ngIf="item.showClientId">{{ item?.ClientId }}</span>
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div class="detail-grid single-col">
                            <div class="detail-item">
                                <ion-icon name="lock-closed-outline"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">Client Secret</span>
                                    <span class="detail-value">
                                        <ion-text class="sensitive-data">••••••••••••</ion-text>
                                        <ion-button fill="clear" size="small" (click)="toggleSSOSecretVisibility(item)">
                                            <ion-icon
                                                [name]="item.showSecret ? 'eye-off-outline' : 'eye-outline'"></ion-icon>
                                        </ion-button>
                                        <span *ngIf="item.showSecret">{{ item?.ClientSecret }}</span>
                                    </span>
                                </div>
                            </div>
                        </div>

                        <!-- Configurações de URL -->
                        <ion-item-divider>
                            <ion-label>URLs</ion-label>
                        </ion-item-divider>

                        <div class="detail-grid single-col">
                            <div class="detail-item">
                                <ion-icon name="link-outline"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">URL de Autorização</span>
                                    <span class="detail-value">
                                        <a href="{{item?.URLAuthorize}}" target="_blank" rel="noopener noreferrer">{{
                                            item?.URLAuthorize }}</a>
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div class="detail-grid single-col">
                            <div class="detail-item">
                                <ion-icon name="server-outline"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">URL do Token</span>
                                    <span class="detail-value">
                                        <a href="{{item?.URLToken}}" target="_blank" rel="noopener noreferrer">{{
                                            item?.URLToken }}</a>
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div class="detail-grid single-col">
                            <div class="detail-item">
                                <ion-icon name="list-outline"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">URL dos Scopes do Token</span>
                                    <span class="detail-value">
                                        <a href="{{item?.URLTokenScopes}}" target="_blank" rel="noopener noreferrer">{{
                                            item?.URLTokenScopes }}</a>
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div class="detail-grid single-col">
                            <div class="detail-item">
                                <ion-icon name="return-down-back-outline"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">Redirect URI Callback</span>
                                    <span class="detail-value">
                                        <a href="{{item?.RedirectUriCallback}}" target="_blank"
                                            rel="noopener noreferrer">{{ item?.RedirectUriCallback }}</a>
                                    </span>
                                </div>
                            </div>
                        </div>

                        <!-- Configurações de Fluxo -->
                        <ion-item-divider>
                            <ion-label>Fluxo OAuth</ion-label>
                        </ion-item-divider>

                        <div class="detail-grid">
                            <div class="detail-item">
                                <ion-icon name="git-compare-outline"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">Grant Type</span>
                                    <span class="detail-value">{{ item?.GrantType }}</span>
                                </div>
                            </div>
                            <div class="detail-item">
                                <ion-icon name="arrow-redo-outline"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">Response Type</span>
                                    <span class="detail-value">{{ item?.ResponseType }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="detail-grid">
                            <div class="detail-item">
                                <ion-icon name="chatbubble-ellipses-outline"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">Prompt</span>
                                    <span class="detail-value">{{ item?.Prompt }}</span>
                                </div>
                            </div>
                            <div class="detail-item">
                                <ion-icon name="flag-outline"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">Prioridade</span>
                                    <span class="detail-value">{{ item?.Priority }}</span>
                                </div>
                            </div>
                        </div>

                        <!-- Scopes -->
                        <ion-item-divider>
                            <ion-label>Scopes</ion-label>
                        </ion-item-divider>

                        <div class="detail-grid single-col">
                            <div class="detail-item">
                                <ion-icon name="list-circle-outline"></ion-icon>
                                <div class="detail-text">
                                    <div class="scopes-list">
                                        <ion-chip *ngFor="let scope of getScopesArray(item?.Scopes)">
                                            {{ scope }}
                                        </ion-chip>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ion-card-content>
                </ion-card>
            </ion-col>

        </ion-row>
    </ion-grid>
</ion-col>
